var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "attach_seo" },
    [
      _c(
        "div",
        [
          _c("yes_no", {
            key: "NO_INDEX",
            attrs: { title: "NO_INDEX" },
            model: {
              value: _vm.no_index,
              callback: function ($$v) {
                _vm.no_index = $$v
              },
              expression: "no_index",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "meta_key",
          f_type: "meta_key",
          f_title: _vm.__t("META_CODE"),
          f_val: _vm.seo.meta_key,
        },
        on: { update_categ: _vm.change_atr },
      }),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "pixel_code",
          f_type: "pixel_code",
          f_title: _vm.__t("FB_PIXEL_CODE"),
          f_val: _vm.seo.pixel_code,
        },
        on: { update_categ: _vm.change_atr },
      }),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "gtag_code",
          f_type: "gtag_code",
          f_title: _vm.__t("GTAG4_CODE"),
          f_val: _vm.seo.gtag_code,
        },
        on: { update_categ: _vm.change_atr },
      }),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "google_measurement_key",
          f_type: "google_measurement_key",
          f_title: _vm.__t("google_measurement_key"),
          f_val: _vm.seo.google_measurement_key,
        },
        on: { update_categ: _vm.change_atr },
      }),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "ga_code",
          f_type: "ga_code",
          f_title: _vm.__t("GA_CODE"),
          f_val: _vm.seo.ga_code,
        },
        on: { update_categ: _vm.change_atr },
      }),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "tiktok_code",
          f_type: "tiktok_code",
          f_title: _vm.__t("TIKTOK_CODE"),
          f_val: _vm.seo.tiktok_code,
        },
        on: { update_categ: _vm.change_atr },
      }),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "seo_title",
          f_type: "seo_title",
          f_title: _vm.__t("SEO_MAIN_TITLE"),
          f_val: _vm.seo.seo_title,
        },
        on: { update_categ: _vm.change_atr },
      }),
      _vm._v(" "),
      _c("info_field", {
        attrs: {
          is_disabled: this.is_disabled,
          f_uniq: "seo_description",
          f_type: "seo_description",
          f_title: _vm.__t("SEO_MAIN_DESCRIPTION"),
          f_val: _vm.seo.seo_description,
        },
        on: { update_categ: _vm.change_atr },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }